import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import ProductGrid from '../components/ProductGrid';

const Products: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Yugoslav Nostalgia T-Shirts, Hoodies & Posters | Born in YU Products</title>
        <meta
          name="description"
          content="Shop unique Yugoslav nostalgia apparel and gifts. T-shirts, hoodies, posters, and tote bags featuring brutalist architecture, Spomenik monuments, and socialist design. Worldwide shipping available."
        />
        <meta
          name="keywords"
          content="Yugoslav t-shirts, Yugoslav apparel, brutalist fashion, Spomenik merchandise, Yugoslav gifts, Balkan nostalgia, socialist design, Yugoslav posters, Yugoslav tote bags"
        />
        <link rel="canonical" href="https://borninyu.com/products" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Yugoslav Nostalgia T-Shirts, Hoodies & Posters | Born in YU" />
        <meta property="og:description" content="Shop unique Yugoslav nostalgia apparel and gifts. T-shirts, hoodies, posters, and tote bags featuring brutalist architecture, Spomenik monuments, and socialist design." />
        <meta property="og:url" content="https://borninyu.com/products" />
        <meta property="og:image" content="https://borninyu.com/og-image.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Yugoslav Nostalgia T-Shirts, Hoodies & Posters | Born in YU" />
        <meta name="twitter:description" content="Shop unique Yugoslav nostalgia apparel and gifts featuring brutalist architecture and Spomenik monuments." />
        <meta name="twitter:image" content="https://borninyu.com/og-image.jpg" />
      </Helmet>

      <main className="min-h-screen bg-[#F0F0F0]">
        <section className="p-6 md:p-12">
          <div className="max-w-6xl mx-auto">
            <div className="border-[3px] border-black bg-white p-8 mb-12">
              <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-4">
                Yugoslav Nostalgia Apparel & Gifts
              </h1>
              <p className="font-typewriter text-sm uppercase text-gray-600 mb-4">
                {t('products.subtitle')}
              </p>
              <p className="text-sm text-gray-700 leading-relaxed normal-case">
                Explore our collection of premium Yugoslav-inspired apparel and gifts. From brutalist architecture t-shirts to Spomenik monument posters, each piece celebrates the unique design heritage of socialist Yugoslavia. High-quality materials, authentic designs, and worldwide shipping.
              </p>
            </div>

            <ProductGrid />
          </div>
        </section>
      </main>
    </>
  );
};

export default Products;
